// extracted by mini-css-extract-plugin
export var descblockImg = "description-block-module--descblock-img--Q-BcI";
export var descHeader = "description-block-module--desc-header--BnSa4";
export var descTextblock = "description-block-module--desc-textblock--PspTq";